import { render } from "./reportBillCost.vue?vue&type=template&id=0ef0173b"
import script from "./reportBillCost.vue?vue&type=script&lang=js"
export * from "./reportBillCost.vue?vue&type=script&lang=js"

import "./reportBillCost.vue?vue&type=style&index=0&id=0ef0173b&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__